import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import type AssignmentsProductManageCurrentRoute from 'teacher-ui-client/assignments/product/manage/current/route'

export default class AssignmentsProductManageCurrentController extends Controller<
  ModelFor<AssignmentsProductManageCurrentRoute>
> {
  @tracked pageNumber = 1

  @tracked perPage = 20

  @tracked sortColumn = 'end_at'

  @tracked sortDirection = 'asc'

  queryParams = ['pageNumber', 'perPage', 'sortColumn', 'sortDirection', 'selectedAssignmentId', 'openMode']

  @tracked selectedAssignmentId?: string

  @tracked openMode?: 'edit' | 'show'

  get totalResults() {
    return this.model.totalAssignments ?? 0
  }

  get totalNumOfPages() {
    return Math.ceil(this.totalResults / this.perPage)
  }

  get assignments() {
    return this.model.assignments.filter((assignment) => assignment.isExpired === false)
  }

  get selectedAssignment() {
    return this.assignments.find((assignment) => this.selectedAssignmentId === assignment.id)
  }

  @action
  showAssignment(id: string) {
    this.selectedAssignmentId = id
    this.openMode = 'show'
  }

  @action
  editAssignment(id: string) {
    this.selectedAssignmentId = id
    this.openMode = 'edit'
  }

  @action
  closeAssignment() {
    if (this.selectedAssignment?.hasDirtyAttributes) this.selectedAssignment.rollbackAttributes()
    this.selectedAssignmentId = undefined
    this.openMode = undefined
  }

  @action
  sortColumnAction(column: string, direction: string) {
    this.sortDirection = direction
    this.sortColumn = column
  }
}

declare module '@ember/controller' {
  interface Registry {
    'assignments/product/manage/current': AssignmentsProductManageCurrentController
  }
}
